/**
 * Energy exchange condition node definition.
 */

import type { NodeDefinition } from '../types';
import type { FlowNode } from '../../../types/flow-types';
import { createEnergyConditionFromFlow } from '../../../converters/helpers/energy-conditions';

export const energyConditionDefinition: NodeDefinition = {
	type: 'energyCondition',
	category: 'condition',
	sourceHandles: ['true', 'false'],

	defaultData: () => ({
		label: 'Energy Exchange Price',
		exchangeMarket: 'Austria',
		operator: 'less than',
		value: 0,
		minutes: 0,
	}),

	toSceneJson: (node: FlowNode) => {
		if (node.data.sceneData) {
			const sceneData = { ...(node.data.sceneData as any) };
			sceneData._fid = sceneData._fid || node.id;
			return sceneData;
		}
		if (node.data.originalCondition) {
			const original = { ...(node.data.originalCondition as any) };
			original._fid = original._fid || node.id;
			return original;
		}

		const result = createEnergyConditionFromFlow({
			value: Number(node.data.value ?? 0),
			operator: (node.data.operator as string) || 'less than',
			exchange_market: (node.data.exchangeMarket as string) || 'Austria',
			minutes: Number(node.data.minutes ?? 0),
		});
		if (!result) return null;
		return { ...result, _fid: node.id };
	},
};
